import { Box, Button } from "@mui/material";

import { Checkmark } from "../../assets/";
import { styled } from "@mui/material/styles";

export const ModalTitleContainer = styled(Box)(({ theme }) => ({
  marginTop: theme.spacing(2),
  marginBottom: theme.spacing(2),
}));

export const ConfirmationButton = styled(Button)(({ theme }) => ({
  marginTop: theme.spacing(2),
  marginBottom: theme.spacing(2),
}));

export const CheckmarkIcon = styled(Checkmark)(({ theme }) => ({
  width: "10vh",
  height: "auto",
}));
